import { PATHS } from '@/constants/Paths';
import { useGetTrashCount } from '@/hooks/useTrash';
import { useTranslation } from '@/i18n';
import { cn } from '@/lib/utils';
import { Trash2 } from 'lucide-react';
import { NavLink } from 'react-router';

const MAX_DISPLAYED_COUNT = 9;

/** Link to the receiver's trash, with the number of items it holds. */
const TrashNavLink = () => {
  const { t } = useTranslation();
  const { data } = useGetTrashCount();
  const count = data?.total ?? 0;

  return (
    <NavLink
      to={PATHS.home.trash}
      title={t('navbar.trash')}
      aria-label={t('navbar.trash')}
      className={({ isActive }) =>
        cn(
          'relative p-3 rounded-full text-gray-600 hover:bg-brand-50 hover:text-brand-600 transition-colors',
          isActive && 'bg-brand-50 text-brand-600',
        )
      }
    >
      <Trash2 className="size-5" />
      {count > 0 && (
        <span className="absolute top-0.5 right-0.5 min-w-5 h-5 px-1 rounded-full bg-error-600 text-white text-xs font-semibold leading-5 text-center">
          {count > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : count}
        </span>
      )}
    </NavLink>
  );
};

export default TrashNavLink;
